import { Add } from "@mui/icons-material";
import { Box, Tab, Tabs } from "@mui/material";
import { ResponsiveButtonLink } from "components/Button";
import { MainLayoutContainer } from "components/Layout";
import { useState } from "react";
import { CustomList, TemplateList } from "./components";
import { TabPanel } from "components/TabPanel";
import { useYearlyCurriculumList } from "./useYearlyCurriculumList";
import { useClinicText } from "hooks/useClinicText";

export const YearlyCurriculumList = () => {
  const [value, setValue] = useState(0);
  const handleChange = (_: any, newValue: number) => {
    setValue(newValue);
  };
  const {
    deleteAcademicYearModal,
    setDeleteAcademicYearModal,
    academicYears,
    handleActionClick,
    handleDelete,
    templates,
    organizationId,
  } = useYearlyCurriculumList();
  const { textYearlyCurriculum } = useClinicText();

  return (
    <MainLayoutContainer
      title={textYearlyCurriculum}
      buttonActions={
        <ResponsiveButtonLink
          to={`/organization/${organizationId}/yearly-curriculum/create/`}
          icon={<Add />}
        >
          New {textYearlyCurriculum}
        </ResponsiveButtonLink>
      }
    >
      <Box>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="Requirement portal tabs"
          >
            <Tab
              label="Custom Programs"
              id="yearly-curriculum-tab-0"
              aria-controls="yearly-curriculum-tabpanel-0"
            />
            <Tab
              label="Default Templates"
              id="yearly-curriculum-tab-1"
              aria-controls="yearly-curriculum-tabpanel-1"
            />
          </Tabs>

          <TabPanel value={value} index={0}>
            <CustomList
              academicYears={academicYears}
              handleActionClick={handleActionClick}
              deleteAcademicYearModal={deleteAcademicYearModal}
              setDeleteAcademicYearModal={setDeleteAcademicYearModal}
              handleDelete={handleDelete}
            />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <TemplateList
              templates={templates}
              organizationId={organizationId ?? ""}
            />
          </TabPanel>
        </Box>
      </Box>
    </MainLayoutContainer>
  );
};
